
import cloneDeep from 'lodash/cloneDeep'

export default {
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'v-custom-search-cp',
  // eslint-disable-next-line vue/require-prop-types
  props: ['type', 'value', 'obj'],
  data() {
    return {
      filteredOptions: [],
      optionSelected: {},
      searchQuery: '',
      loading: false,
      numberRule: [
        (v) => !v || /^-?\d*\.?\d+$/.test(v) || this.$t('invalidNumber'),
      ],
      calle: '',
      municipio: '',
      entidadFederativa: '',
      errorMessage: '',
      numeroInterior: '',
      numeroExterior: '',
      entreCalle1: '',
      yCalle2: '',
      referenciasAdicionales: '',
    }
  },
  async fetch() {},
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.searchQuery = this.optionSelected.cp
        this.optionSelected = cloneDeep(val)
        this.setAddress()
      }
    },
    searchQuery(val) {
      if (!val) {
        this.clearData()
      }
    },
  },
  mounted() {
    if (this.value) {
      this.searchQuery = this.value.cp
      this.optionSelected = Object.assign({}, this.value)
      if (this.searchQuery) {
        this.getCpData()
      }
    }
  },
  methods: {
    clearData() {
      this.calle = ''
      this.municipio = ''
      this.searchQuery = ''
      this.optionSelected = {}
      this.filteredOptions = [] // Clear the suggestions
      this.entidadFederativa = ''
      this.numeroInterior = ''
      this.numeroExterior = ''
      this.entreCalle1 = ''
      this.yCalle2 = ''
      this.referenciasAdicionales = ''
    },
    emitOption() {
      this.optionSelected.numeroInterior = this.numeroInterior
      this.optionSelected.numeroExterior = this.numeroExterior
      this.optionSelected.entreCalle1 = this.entreCalle1
      this.optionSelected.yCalle2 = this.yCalle2
      this.optionSelected.calle = this.calle
      this.optionSelected.referenciasAdicionales = this.referenciasAdicionales
      this.$emit('input', this.optionSelected)
    },
    setAddress() {
      this.municipio = this.optionSelected.municipio
      this.entidadFederativa = this.optionSelected.entidadFederativa
      this.numeroInterior = this.optionSelected.numeroInterior
      this.numeroExterior = this.optionSelected.numeroExterior
      this.entreCalle1 = this.optionSelected.entreCalle1
      this.yCalle2 = this.optionSelected.yCalle2
      this.calle = this.optionSelected.calle
      this.referenciasAdicionales = this.optionSelected.referenciasAdicionales
    },
    async getCpData() {
      try {
        this.errorMessage = ''
        const cp = parseInt(this.searchQuery, 10)
        const query = this.$fire.firestore
          .collection('sepomex')
          .where('cp', '==', cp)

        // Get the snapshot of the query results
        const querySnapshot = await query.get()

        if (querySnapshot.empty) {
          this.clearData()
          this.errorMessage = this.$t('procedures.noInfoTitle')
          return
        }

        // Loop through the documents in the snapshot
        this.filteredOptions = querySnapshot.docs.map((doc) => doc.data())

        if (this.optionSelected?.colonia) {
          const matchedOption = this.filteredOptions.find(
            (opt) => opt.colonia === this.optionSelected.colonia
          )

          if (matchedOption) {
            // Hace un merge de los datos encontrados en optionSelected
            Object.assign(this.optionSelected, matchedOption)
            this.setAddress()
          } else {
            // Si no encontró una coincidencia específica, selecciona la primera opción
            this.optionSelected = cloneDeep(this.filteredOptions[0])
            this.emitOption()
          }
        } else {
          this.optionSelected = cloneDeep(this.filteredOptions[0])
          this.emitOption()
        }
      } catch (error) {
        this.clearData()
        this.errorMessage = `${this.$t(
          'editor.an-error-has-occurred-please-try-again'
        )}: ${error}`
      }
    },
  },
}
